import React from 'react';
import { View, Text } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import styles from './styles';

const QrCodeConfirmPay = () => {
    return (
        <>
            <HeaderDefault title={"QrCode"} />

            <View style={styles.container}>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do pagamento:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Moeda:</Text>
                    <Text>GPX TOKEN</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={"CONTINUAR"} titlePage={"Confirmar pagamento"} />
        </>
    );
}

export default QrCodeConfirmPay;